export default "/images/default-bg.jpg";